import React from "react";
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    Image
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
    cvTitle: {
      fontSize: 24,
  
    },
    cvSubtitle: {
      fontSize: 18,
      marginTop: 12,
    },
    cvInfo: {
      fontSize: 16,
      marginTop: 12,
    },
    cvOtherInfo: {
      fontSize: 14,
      marginTop: 11,
      lineHeight: 1.5
    },
    
    cvFooter:{
        marginTop: 40,
        fontSize: 14,
    },
  
    cvTableHeader:{
      marginTop: 15,
      borderBottom:'1 solid black',
      display:'flex',
      flexDirection: 'row',
      justifyContent:'space-between'
    },
    
    cvTableItem:{
      display:'flex',
      flexDirection: 'row',
      justifyContent:'space-between'
    },
    
    
    cvTblHeader1:{
        fontSize: 14,
        minWidth:'10',
        maxWidth:'10',
    },
    cvTblHeader2:{
        fontSize: 14,
        minWidth:'120',
        maxWidth:'120',
    },
    cvTblHeader3:{
        fontSize: 13,
        minWidth:'110',
        maxWidth:'110',
    },
    cvTblHeader4:{
        fontSize: 13,
        minWidth:'85',
        maxWidth:'85',
    },
     
    cvTblItem1:{
        fontSize: 14,
        minWidth:'10',
        maxWidth:'10',
    },
    cvTblItem2:{
        fontSize: 13,
        minWidth:'120',
       maxWidth:'120',
      alignItems:"flex-start",
    },
    cvTblItem3:{
      fontSize: 14,
        minWidth:'110',
        maxWidth:'110',
      alignItems:"flex-end",
    },
    
    cvTblItem4:{
        fontSize: 13,
        minWidth:'85',
        maxWidth:'85',
      alignItems:"flex-end",
    }, 
    
    
    body: {
      paddingTop: 35,
      paddingBottom: 65,
      paddingHorizontal: 35,
    },
    title: {
      fontSize: 24,
      textAlign: 'center',
      fontFamily: 'Oswald'
    },
    subtitle: {
      fontSize: 18,
      margin: 12,
      fontFamily: 'Oswald'
    },
  
    pageNumber: {
      position: 'absolute',
      fontSize: 12,
      bottom: 30,
      left: 0,
      right: 0,
      textAlign: 'center',
      color: 'grey',
    },
  });

export function CashVoucherPdf(props) {
  const {cvDetails, items} = props;
    return (
      <Document>
         <Page size="A4" style={styles.body}>
           <View style={styles.cvTitle}>
             <Text>{cvDetails.title || ""}</Text>
           </View>
           <View style={styles.cvSubtitle}>
             <Text>{cvDetails.trandate || ""}</Text>
           </View>
           <View style={styles.cvInfo}>
             <Text>Cash Voucher Information</Text>
           </View>
           <View style={styles.cvOtherInfo}>
             <Text>Allocated To: {cvDetails.payto || ""}</Text>
             <Text>Created By: {cvDetails.created_by || ""}</Text>
             <Text>Approved By: {cvDetails.approved_by || ""}</Text>
           </View>
           
            <View style={styles.cvTableHeader}>
             <Text style={styles.cvTblHeader1}>ID</Text>
             <Text style={styles.cvTblHeader2}>Details</Text>
             <Text style={styles.cvTblHeader3}>Released Amount</Text>
             <Text style={styles.cvTblHeader4}>Actual Amount</Text>
            </View>
            
           <View style={styles.cvTableItem}>
             <View style={styles.cvTblItem1}>  
                  <Text style={styles.item1}>{items.id || ""}</Text>
             </View>
             <View style={styles.cvTblItem2}>  
                  <Text style={styles.item2}>{items.details || ""}</Text>
             </View>
             <View style={styles.cvTblItem3}>  
                  <Text style={styles.item3}>{items.released_amount || ""}</Text>
             </View>
             <View style={styles.cvTblItem4}>  
                  <Text style={styles.item4}>{items.actual_amount || ""}</Text>
             </View>
            </View>
           
            <View style={styles.cvFooter}>
             <Text>Received By:</Text>
           </View>
         </Page>
       </Document>
     );
};  
   